import type { Channel } from '../types';
import { progressFor, shortTime } from '../core/catalog';

interface Props {
  channel: Channel;
  onPlay: (channel: Channel) => void;
  onPreview: (channel: Channel) => void;
}

export function ChannelCard({ channel, onPlay, onPreview }: Props) {
  return (
    <button
      className="channel-card"
      data-focusable="true"
      data-focus-zone="channels"
      data-focus-key={`channel-${channel.id}`}
      data-testid={`channel-${channel.channel_number}`}
      onClick={() => onPlay(channel)}
      onFocus={() => onPreview(channel)}
    >
      <span className="channel-card__art">
        {channel.background_image_web || channel.background_image
          ? <img className="channel-card__background" src={channel.background_image_web || channel.background_image} alt="" loading="lazy" />
          : <img className="channel-card__logo" src={channel.image} alt="" loading="lazy" />}
      </span>
      <span className="channel-card__meta">
        <span className="channel-card__number">{String(channel.channel_number).padStart(2, '0')}</span>
        <span className="channel-card__text">
          <strong>{channel.name}</strong>
          <small>{channel.currentProgram?.name || 'Programação ao vivo'}</small>
        </span>
      </span>
      <span className="program-progress"><i style={{ width: `${progressFor(channel.currentProgram)}%` }} /></span>
      <span className="channel-card__time">
        {shortTime(channel.currentProgram?.time_start)}–{shortTime(channel.currentProgram?.time_end)}
      </span>
    </button>
  );
}
